var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-full"},[_c('v-progress-circular',{attrs:{"size":65,"width":3,"color":"primary","indeterminate":""}},[_c('v-img',{attrs:{"src":require('@/assets/images/swagbox-icon.png'),"contain":"","alt":"Swagbox Logo","height":"36"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }